import { Outlet } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { inject, observer } from 'mobx-react';
import { Storage } from '@/utils/Storage';
import { v4 as uuidv4 } from 'uuid';
import withRouter from '@/components/withRouter';
// 预留外部智能体的初始逻辑
const MobileOutSideLayout = (props) => {
    const [loading, setLoading] = useState(true);
    let { grtAi, chatStore, skill } = props.store;
    let { agentId } = props.params;
    const initLocalId = () => {
        let LocalOuid = Storage.get('ouid');
        if (!LocalOuid) {
            let uuid = uuidv4();
            Storage.set('ouid', uuid);
        }
    };
    const init = async () => {
        await grtAi.setAgentId(agentId);
        await grtAi.setNavigate(props.navigate);
        await grtAi.setSide('mobile');
        await grtAi.setSearchParams(props.searchParams);
        await chatStore.setAgentId(agentId);
        await chatStore.setNavigate(props.navigate);
        await chatStore.setSide('mobile');
        await grtAi.checkLogin(true);
        initLocalId();
        setLoading(false);
    };
    useEffect(() => {
        init();
    }, []);
    return loading ? null : <Outlet></Outlet>;
};

export default withRouter(inject('store')(observer(MobileOutSideLayout)));
